export default __webpack_public_path__ + "assets/logo-5a22cef8ebd5225899560177e78fb575.svg";